import type { RewardType } from "@jti/rest-api-types";
import { useTranslations } from "@jti/ui/providers/useTranslations";
import { formatDate } from "@jti/ui/utils/formatDate/formatDate";
import { replaceStringPlaceholder } from "@jti/ui/utils/replaceStringPlaceholder";

import { PRIZE_TYPE_SUFFIX } from "../../../hooks/useLoyaltyPrizeCta/constants";
import type { DialogStep } from "../RedeemDialogV2.types";

type UseRedeemDialogHeaderTranslationsInputs = {
  step: DialogStep;
  rewardType: RewardType;
  won?: boolean;
  timeTo?: Date | string;
};

type UseRedeemDialogHeaderTranslationsOutputs = {
  dialogTitle: string;
  dialogDescription: string;
};

export function useRedeemDialogHeaderTranslations({
  step,
  rewardType,
  won,
  timeTo,
}: UseRedeemDialogHeaderTranslationsInputs): UseRedeemDialogHeaderTranslationsOutputs {
  const { __ } = useTranslations();

  if (step === "editAddress") {
    return {
      dialogTitle: __(`loyalty.redeemDialog.dialogTitle.editAddress`),
      dialogDescription: __(`loyalty.redeemDialog.dialogDescription.editAddress`),
    };
  }

  const isInstantLottery = rewardType?.includes(PRIZE_TYPE_SUFFIX.instant);

  if (step === "confirmation" && isInstantLottery) {
    const outcome = won ? "win" : "lost";

    return {
      dialogTitle: __(`loyalty.redeemDialog.instant_lottery_physical.dialogTitle.confirmation.${outcome}`),
      dialogDescription: __(`loyalty.redeemDialog.instant_lottery_physical.dialogDescription.confirmation.${outcome}`),
    };
  }

  const populatedDynamicDescription = replaceStringPlaceholder(
    __(`loyalty.redeemDialog.${rewardType}.dialogDescription.${step}`),
    [
      {
        placeholder: "date",
        value: formatDate(timeTo),
      },
    ],
    false
  );

  return {
    dialogTitle: __(`loyalty.redeemDialog.${rewardType}.dialogTitle.${step}`),
    dialogDescription: populatedDynamicDescription,
  };
}
